<template>
    <c-header
        id="app-header"
        class="justify-content-between align-items-center"
        position="sticky"
    >
        <c-container class="p-0 px-md-2" fluid>
            <slot />
        </c-container>
    </c-header>
</template>
<script setup>
import { CHeader } from '@coreui/vue/dist/esm/components/header/index.js';
import { CContainer } from '@coreui/vue/dist/esm/components/grid/index.js';
</script>
